import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '@cityelectricalfactors/ui-components';
import ProductStock from './product_stock';
import ProductStoreModal from './product_store_modal';
import TrustBox from '../trustpilot/trustpilot_widgets/trustbox';

const StandardProduct = ({
  product,
  tradeEssentials,
  currentStore,
  icons,
  addToBasket,
  compare,
  index,
  viewProduct,
  loadingPrices,
  getPrice,
  branchStocks,
  collectionSet,
  getBranchStock,
  selectAStoreUrl,
}) => {
  const {
    brand,
    id,
    stock_code: stockCode,
    primary_root_category: primaryRootCategory,
    brand_image: brandImage,
    url,
    description_short: descriptionShort,
    image_small: imageSmall,
    brand_and_description_short: brandAndDescriptionShort,
    catalogue,
    collection_only: collectionOnly,
    third_party_logistical_partner: thirdPartyLogisticalPartner,
  } = product;

  const { trade, collection_only: collectionOnlyIcon } = icons;

  const [showProductStoreModal, setShowProductStoreModal] = useState(false);

  return (
    <div
      className="span4 product--listings_product loading"
      data-brand={brand}
      data-idvariant={id}
      data-productid={stockCode}
      data-category={primaryRootCategory}>
      <div className="product-listings__additional-images fl jc-sb image__list-item">
        {brandImage && (
          <img
            // eslint-disable-next-line max-len
            className="product-listings__additional-image product-listings__additional-image--brand image__list-image image__list-lazy-image"
            src={brandImage}
            alt=""
          />
        )}

        {tradeEssentials && (
          <img
            alt="Trade Essentials"
            className="product-listings__additional-image product-listings__additional-image--trade"
            src={trade}
          />
        )}
      </div>
      <a
        className="product-listings__image-wrapper fl image__list-item"
        href={url}
        onClick={e => {
          e.preventDefault();
          viewProduct(url, stockCode, index + 1);
        }}>
        <img
          alt={`${brand} - ${descriptionShort}`}
          data-src={imageSmall}
          className="product--image_small image__list-image image__list-lazy-image"
        />
      </a>

      <a
        href={url}
        onClick={e => {
          e.preventDefault();
          viewProduct(url, stockCode, index + 1);
        }}>
        <h3>{brandAndDescriptionShort}</h3>
      </a>

      <ul className="product-listings__codes">
        <li>
          <strong>Stock Code:</strong>{' '}
          <span className="product-listings__stock-code">{stockCode}</span>
        </li>
        <li>
          <strong>Part Code:</strong>{' '}
          <span className="product-listings__part-code">{catalogue}</span>
        </li>
      </ul>
      <TrustBox id={id} templateId="54d39695764ea907c0f34825" />

      <div>
        {loadingPrices && <div className="loader" />}
        {getPrice(id)}
      </div>
      {!thirdPartyLogisticalPartner && (
        <>
          <ProductStock
            branchStocks={branchStocks}
            collectionSet={collectionSet}
            getBranchStock={getBranchStock}
            product={product}
          />
        </>
      )}
      <div className="product--actions">
        {!thirdPartyLogisticalPartner ? (
          <>
            {!collectionOnly ? (
              addToBasket
            ) : (
              <div className="product--listings_collection-only-message">
                <p className="collection-only-message">
                  <img src={collectionOnlyIcon} alt="" />
                  <span>Collection only</span>
                </p>
                <a
                  className="collection-only-message-link"
                  href={url}
                  onClick={e => {
                    e.preventDefault();
                    viewProduct(url, stockCode, index + 1);
                  }}>
                  View Product
                </a>
              </div>
            )}
          </>
        ) : (
          <>
            {collectionSet ? (
              <>
                <ContactStoreButton
                  className="cef-btn cef-btn--grey fs-16 fw-500"
                  handleClick={() => setShowProductStoreModal(true)}>
                  Contact Store to Order
                </ContactStoreButton>
                <ProductStoreModal
                  catalogue={catalogue}
                  selectAStoreUrl={selectAStoreUrl}
                  modalIsOpen={showProductStoreModal}
                  closeModal={() => setShowProductStoreModal(false)}
                  currentStore={currentStore}
                  currentProductName={brandAndDescriptionShort}
                />
              </>
            ) : (
              <ContactStoreLink
                className="cef-btn cef-btn--grey fs-16 fw-500"
                href={selectAStoreUrl}>
                Contact Store to Order
              </ContactStoreLink>
            )}
          </>
        )}
        {compare}
      </div>
    </div>
  );
};

const ContactStoreButton = styled(Button)`
  height: 40px;
  margin-top: 117px;
  width: 100%;
`;

const ContactStoreLink = styled.a`
  height: 40px;
  margin-top: 117px;
  width: 100%;
`;

export default StandardProduct;
